import { inject, observer } from 'mobx-react';

import { Display } from '@/components/Display/Display';

import References from '../References';
import ChatFiles from '../ChatFiles';
import UserMessage from '@/pages/Web/PageComponents/CaseSimulation/UserMessage';
import MultimodalReference from '../../Web/PageComponents/MultimodalLearning/MultimodalReference';
import useMultimodalReference from '@/pages/hooks/Multimodal/useMultimodalReference';
const LocalRender = (props) => {
    let { message, side, store, item } = props;
    let { skillStore, multimodalStore } = store;
    let { curSkill, isTargetSkillType } = skillStore;
    const { setMultimodalReference } = multimodalStore;
    let { component, file_json, references, multimodal_reference } = item;
    // multimodal helpers
    const { createOpenHistoryMultimodalList } = useMultimodalReference();
    // 如果历史消息只有 references，但没有 multimodal_reference，则在渲染时构造一个临时的 multimodal_reference 以便显示引用卡片
    const videoReferences = references && Array.isArray(references) ? references.filter((ref) => ref.image_url || ref.title) : [];
    const localMultimodalReference =
        multimodal_reference ||
        (videoReferences && videoReferences.length
            ? {
                  title: '多模态学习',
                  description: '',
                  videoCount: videoReferences.length,
                  firstVideoTitle: videoReferences[0]?.title || '',
                  reference_id: item.reference_id || null,
                  // onListClick: 可在父组件中传入或使用回调
                  onListClick: () => {}
              }
            : null);
    // prepare history list opener
    const openHistoryList = createOpenHistoryMultimodalList ? createOpenHistoryMultimodalList({ setMultimodalReference }) : null;
    return (
        <>
            <Display show={references && references?.length}>
                <References curSkill={curSkill} isTargetSkillType={isTargetSkillType} side={side} files={references} from="chat"></References>
            </Display>
            <Display show={side === 'web' && localMultimodalReference}>
                <MultimodalReference
                    data={localMultimodalReference}
                    from="chat"
                    onClick={() => {
                        try {
                            // 将引用写回全局状态，确保包含打开历史列表的回调
                            if (setMultimodalReference) {
                                const payload = {
                                    ...localMultimodalReference,
                                    videoReferences,
                                    onListClick: () => {
                                        try {
                                            if (openHistoryList && videoReferences && videoReferences.length) {
                                                openHistoryList(videoReferences);
                                            }
                                        } catch (err) {
                                            console.error('openHistoryList error', err);
                                        }
                                    }
                                };

                                setMultimodalReference(payload);
                            }
                            // 聚焦输入框
                            setTimeout(() => {
                                const el = document.getElementById('web-send-input');
                                if (el && typeof el.focus === 'function') el.focus();
                            }, 30);
                        } catch (e) {
                            console.error('click multimodal reference in history error', e);
                        }
                    }}
                    onListClick={() => {
                        try {
                            if (openHistoryList && videoReferences && videoReferences.length) {
                                openHistoryList(videoReferences);
                            }
                        } catch (e) {
                            console.error('open history list error', e);
                        }
                    }}
                />
            </Display>
            <Display show={file_json && Array.isArray(file_json) && file_json.length}>
                {/* <AgentFile side={side} fileList={file_json} from="chat" /> */}
                <ChatFiles side={side} fileList={file_json} />
            </Display>
            <Display show={component}>
                <UserMessage card={component}></UserMessage>
            </Display>
            <Display show={message}>
                <div className="ai-user-question-wrap">
                    <div className="ai-user-question">{message}</div>
                </div>
            </Display>
        </>
    );
};

export default inject('store')(observer(LocalRender));
